<template>
  <div class="col options-container">
    <div class="row gx-0">
      <template v-for="(resultat, index) in resultats" :key="resultat">
        <template v-if="choosenOptions.includes(index) && objectHelper.isDefined(resultat.garantie) && resultats.some((x) => x.garantie.id == resultat.garantie.id)">
          <div class="col">
            <DisplayResultColumn :cssClass="resultat.garantie.cssClass + ' result-example'">
              <template v-slot:maladie>
                <div class="line">
                  <div class="montant">{{ objectHelper.formatMoney(getResultat(resultat.garantie.id).cotisationPreleveeSurBulletinDePaie) }}</div>
                </div>
                <div class="line">
                  <div class="montant">{{ objectHelper.formatMoney(getResultat(resultat.garantie.id).cotisationPreleveeSurCompteBancaire) }}</div>
                </div>
              </template>
            </DisplayResultColumn>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import objectHelper from "@/classes/helpers/objectHelper";
import UserInformations from "@/classes/dto/userInformations";
import * as GARANTIES from "@/classes/parametrage/options";
import DisplayResultColumn from "./DisplayResultColumn.vue";

export default {
  name: "DisplayResultPrelevements",
  components: { DisplayResultColumn },
  data() {
    return {
      GARANTIES,
      objectHelper,
    };
  },
  props: {
    userInput: {
      type: UserInformations,
      default: new UserInformations(),
    },
    choosenOptions: {
      type: Array,
      default: undefined,
    },
    resultats: {
      type: Array,
      default: undefined,
    },
  },
  methods: {
    getResultat(idGarantie) {
      return this.resultats.find((x) => x.garantie.id == idGarantie);
    },
    getCotisationTotale(idGarantie) {
      return Math.floor(this.getResultat(idGarantie).cotisationMensuelleApresEmployeur * 12);
    },
    getRemunerationTotale(idGarantie) {
      var pleinTraitement = this.getResultat(idGarantie).maladie.ordinaire.pleinTraitement;
      var demiTraitement = this.getResultat(idGarantie).maladie.ordinaire.demiTraitement;
      return Math.floor(pleinTraitement * 3 + demiTraitement * 9);
    },
    getPrestationsRegimePrevoyance(idGarantie) {
      var remunerationTotaleObligationStatutaire = this.getRemunerationTotale(GARANTIES.OBLIGATION_STATUTAIRE);
      var remunerationTotaleGarantie = this.getRemunerationTotale(idGarantie);
      return remunerationTotaleGarantie - remunerationTotaleObligationStatutaire;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.options-container {
  page-break-inside: avoid !important;
}
</style>
